import Request from "../../lib/request";
import { PROJECT_USER_ID } from "../../constants/storageKeys";
import {
  CURRENT_COMPARISON_API,
  IMPRESTS_BUDGETS_API,
  PROJECT_USERS_API
} from "../../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const pettyCashierGetBudgetComparisonInfo = () => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_BUDGETS_API}/${CURRENT_COMPARISON_API}`,
    needToken: true
  });
};
